import Icon from '../components/Icon';

const Lightning = Icon(
  'lightning',
  <>
    <path
      fillRule="evenodd"
      d="M15.343.833a.75.75 0 0 1 .392.814l-1.374 6.875 5.402 2.026a.75.75 0 0 1 .285 1.214l-10.5 11.25a.75.75 0 0 1-1.283-.66l1.374-6.874-5.402-2.026a.75.75 0 0 1-.285-1.214l10.5-11.25a.75.75 0 0 1 .89-.155m-9.53 11.609 4.95 1.856a.75.75 0 0 1 .472.85l-.982 4.91 7.933-8.5-4.95-1.856a.75.75 0 0 1-.471-.85l.982-4.91z"
      clipRule="evenodd"
    />
  </>
);

export default Lightning;
